import processResetTotalsReasonAdjs from './processResetTotalsReasonAdjs'
//------------------------------------------
// process reset totals reason adjs harness
//------------------------------------------
export default function processResetTotalsReasonAdjsHarness({ adjs, category, character } = {}) {
  //-----------------------
  // defensive check parms
  //-----------------------
  if (!adjs || !category || !character) {
    console.error('processResetTotalsReasonAdjsHarness: missing required parms')
    return { adjs, category, character }
  }
  //-----------------------------------------------------------------------------------
  // get unique adj names affected (set auto removes dupes where '...' provides array)
  //-----------------------------------------------------------------------------------
  const affectedAdjs = [...new Set(adjs.map((adj) => adj.name))]
  //--------------------------------
  // process each affected adj once
  //--------------------------------
  affectedAdjs.forEach((adjName) => {
    //-------------
    // set payload
    //-------------
    const payload = {
      category: category, // 'skill' | 'ability' | 'characteristic'
      type: adjName,
      data: character[`${category}_adjs`].filter((adj) => adj.name === adjName),
    }
    //----------------------------------
    // process reset totals reason adjs
    //----------------------------------
    character = processResetTotalsReasonAdjs({ payload, character })
  })
  //--------------------------------------------------------------
  // return mutated objects for clarity (optional use by callers)
  //--------------------------------------------------------------
  return character
}
